import i18n from '@locales/i18n';

interface Props {
    name: string;
    nameEn?: string;
    nameJa?: string;
}

function getGlobalName({ name, nameEn, nameJa }:Props): string {
    const { language } = i18n;
    switch (language) {
    case 'ja':
        return nameJa || nameEn || name;
    case 'en':
        return nameEn || name;
    default:
        return name;
    }
}

export default getGlobalName;
